import { LOGIN, LOGOUT, UPDATE_FIELD_AUTH } from "../constants/actionTypes";
import jwt_decode from "jwt-decode";

const defaultState = { jwt: undefined, currentUser: undefined };

export default (state = defaultState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
      return {
        ...state,
        jwt: payload,
        currentUser: payload ? jwt_decode(payload.AccessToken) : undefined,
      };
    case LOGOUT:
      return {
        ...state,
        jwt: null,
      };
    case UPDATE_FIELD_AUTH:
      return {
        ...state,
        [action.key]: action.value,
      };
    default:
      return state;
  }
};
